/**
 * Reads the primary participant id off a signed document. The reference resolves
 * to a bare id string when requested via `paths`, or to an expanded `{ _id }`
 * object; support both so the caller can pick the cheapest fetch.
 */
export const extractPrimaryParticipantId = (signedDocument) => {
    const participant = signedDocument === null || signedDocument === void 0 ? void 0 : signedDocument.ec__primary_participant;
    if (typeof participant === 'string') {
        return participant || undefined;
    }
    const participantId = participant === null || participant === void 0 ? void 0 : participant._id;
    return typeof participantId === 'string' && participantId ? participantId : undefined;
};
/**
 * Finds the MOM environment id (the site route's `:studyId`) for a Cortex org
 * code from the identity's `environmentSites` payload. Matching on the org code
 * keeps the anonymous invite decoupled from any Studio numeric ids.
 */
export const findEnvironmentIdByOrgCode = (environmentSites, orgCode) => {
    if (!Array.isArray(environmentSites)) {
        return undefined;
    }
    const normalizedOrgCode = orgCode.toLowerCase();
    for (const site of environmentSites) {
        const environment = site === null || site === void 0 ? void 0 : site.environment;
        const code = environment === null || environment === void 0 ? void 0 : environment.code;
        const id = environment === null || environment === void 0 ? void 0 : environment.id;
        if (typeof code === 'string' && code.toLowerCase() === normalizedOrgCode && typeof id === 'number') {
            return id;
        }
    }
    return undefined;
};
export const buildParticipantConsentPath = (environmentId, participantId) => `/site/study/${environmentId}/participants/${participantId}#documents`;
